module.exports = __webpack_public_path__ + "static/media/clientDummy.ce3ac492.png";